import { useEffect, useState } from 'react'
import { consumirApi } from '../../utils/consumoApi'
import { useNavigate } from 'react-router-dom'
import ErrorAlert from '../../components/common/ErrorAlert'
import Input from '../../components/common/Input'
import Form from '../../components/forms/Form'
import Modal from '../../components/modals/Modal'
import ModalConfirmacion from '../../components/modals/ModalConfirmacion'
import Button from '../../components/common/Button'
import Notification from '../../components/common/Notification'
import Spinner from '../../components/common/Spinner'
import Table from '../../components/tables/TableFilter'


const Empresa = () => {
    const [datos, setDatos] = useState([])
    // campos
    const [idEmpresa, setIdEmpresa] = useState('')
    const [rucEmpresa, setRucEmpresa] = useState('')
    const [razonSocialEmpresa, setRazonSocialEmpresa] = useState('')
    const [partidaEmpresa, setPartidaEmpresa] = useState('')
    const [domicilioEmpresa, setDomicilioEmpresa] = useState('')
    const [distritoEmpresa, setDistritoEmpresa] = useState('')
    const [provinciaEmpresa, setProvinciaEmpresa] = useState('')
    const [departamentoEmpresa, setDepartamentoEmpresa] = useState('')
    const [dniRepresentanteEmpresa, setDniRepresentanteEmpresa] = useState('')
    const [nombresRepresentanteEmpresa, setNombresRepresentanteEmpresa] = useState('')
    const [mensajeEmpresa, setMensajeEmpresa] = useState('')
    const [logoEmpresa, setLogoEmpresa] = useState('')
    const [logoRepresentante, setLogoRepresentante] = useState('')
    const [fotoRepresentante, setFotoRepresentante] = useState('')
    const [selectedId, setSelectedId] = useState(null)
    const navigate = useNavigate()
    // Modales 
    const [mostrarModal, setMostrarModal] = useState(false)
    const [mostrarModalEliminar, setMostrarModalEliminar] = useState(false)
    // notificaiones y cargas
    const [cargando, setCargando] = useState(true)
    const [cargandoReniec, setCargandoReniec] = useState(false)
    const [error, setError] = useState('')
    const [notificacion, setNotificacion] = useState({ estado: false, tipo: "", mensaje: "" })
    const [isSubmitting, setIsSubmitting] = useState(false)
    //datos para la tabla
    const columnas = [
        { titulo: 'Ruc', campo: 'ruc_empresa' },
        { titulo: 'Razon social', campo: 'razon_social_empresa' },
        { titulo: 'Representante', campo: 'nombres_representante_empresa' },
    ]

    // Carga inicial de la información de   la empresa
    useEffect(() => { obtenerEmpresas() }, [])

    // Función para traer información de la empresa
    const obtenerEmpresas = async () => {
        const respuesta = await consumirApi('GET', 'maestros/empresa')
        setDatos(respuesta.success ? respuesta.data : [])
        setCargando(false)
    }

    // FUncion para buscar en la BD de RENIEC el DNI
    const obtenerPersona = async (dni) => {
        setDniRepresentanteEmpresa(dni)
        setNombresRepresentanteEmpresa('')
        if (dni.length === 8) {
            setCargandoReniec(true)
            const respuesta = await consumirApi('GET', `reniec/${dni}`)
            const datos = respuesta.data[0]
            if (datos) {
                setNombresRepresentanteEmpresa(datos.nombre + ' ' + datos.ape_pat + ' ' + datos.ape_mat)
            }
            setCargandoReniec(false)
        }
    }

    // funcion para registrar informacion de la empresa 
    const registrarEmpresa = async (e) => {
        e.preventDefault()
        const formData = new FormData(e.target)
        setIsSubmitting(true)
        const respuesta = await consumirApi('POST', 'maestros/empresa', formData)
        if (respuesta.success) {
            setNotificacion({ estado: true, tipo: 'success', mensaje: 'Datos guardados con éxito' })
            limpiarCampos()
            obtenerEmpresas()
        } else {
            setError(respuesta.error)
            setIsSubmitting(false)
        }
    }

    // seleccionar una empresa 
    const seleccionEmpresa = (data) => {
        setSelectedId((prevSelectedId) => (prevSelectedId === data.id ? null : data.id))
    }

    //Funcion para redirigir a la pestaña de editar empresa
    const editarEmpresa = async (data) => {
        setIdEmpresa(data.id)
        navigate("/maestros/editar_empresa", { state: { id: data.id } })
    }

     // funcion para enviar la eliminación de un espacio
     const eliminarEmpresa = async () => {
        const respuesta = await consumirApi('DELETE', `maestros/empresa/${selectedId}`)
        if (respuesta.success) {
            setNotificacion({ estado: true, tipo: "eliminar", mensaje: "Empresa eliminado correctamente" })
            limpiarCampos()
            obtenerEmpresas()
        } else {
            setError(respuesta.error)
        }
    }

    const limpiarCampos = () => {
        setMostrarModal(false)
        setMostrarModalEliminar(false)
        setError('')
        setTimeout(() => {
            setIsSubmitting(false)
        }, 300)
    }

    return (
        <div style={{ maxHeight: 'calc(100vh - 50px)' }} className="w-full overflow-y-auto bg-gray-50">
            <Button className="ml-5 mt-2" texto="+ Nuevo" onClick={() => setMostrarModal(true)} />
            <Button className="ml-3 mt-2"  type="delete" disabled={!selectedId} onClick={() => setMostrarModalEliminar(true)} />
            {notificacion.estado && (
                <Notification estadoNotificacion={setNotificacion} type={notificacion.tipo} mensaje={notificacion.mensaje} />
            )}
            {cargando ? (
                <Spinner />
            ) : datos.length === 0 ? (
                <div className="ml-5">Sin datos</div>
            ) : (
                <Table datos={datos} listaCampos={columnas} editarRegistro={editarEmpresa}
                    mostrarChecks={true}
                    seleccionFila={seleccionEmpresa} // Manejar el ID seleccionado
                    selectedId={selectedId} // Manejar el ID seleccionado
                />

            )}

            {/* Modal para registrar empresa*/}
            <Modal isOpen={mostrarModal} title={`Registrar Datos`} onClose={limpiarCampos} sizeModal='4xl'>
                <Form onSubmit={registrarEmpresa} texto="Registrar" isSubmitting={isSubmitting}>
                    <div className='flex gap-2 flex-1'>
                        <Input name="ruc_empresa" value={rucEmpresa} label="RUC" type="number" onChange={setRucEmpresa} />
                        <div className="flex-1">
                            <Input name="razon_social_empresa" value={razonSocialEmpresa} label="Razón social" onChange={setRazonSocialEmpresa} />
                        </div>
                    </div>
                    <div className='flex gap-2'>
                        <Input name="partida_empresa" type="number" value={partidaEmpresa} label="Partida" onChange={setPartidaEmpresa} />
                        <div className="flex-1">
                            <Input name="domicilio_empresa" value={domicilioEmpresa} label="Domicilio" onChange={setDomicilioEmpresa} />
                        </div>
                        <Input name="distrito_empresa" value={distritoEmpresa} label="Distrito" onChange={setDistritoEmpresa} />
                    </div>
                    <div className='flex gap-2'>
                        <Input name="provincia_empresa" value={provinciaEmpresa} label="Provincia " onChange={setProvinciaEmpresa} />
                        <Input name="departamento_empresa" value={departamentoEmpresa} label="Departamento" onChange={setDepartamentoEmpresa} />
                        <Input name="dni_representante_empresa" value={dniRepresentanteEmpresa} label="DNI representante" type="number" onChange={obtenerPersona} carga={cargandoReniec} />
                        <Input name="nombres_representante_empresa" value={nombresRepresentanteEmpresa} label="Nombres representante" onChange={setNombresRepresentanteEmpresa} />
                    </div>
                    <Input name="mensaje_empresa" type="textarea" value={mensajeEmpresa} label="Mensaje empresa" onChange={setMensajeEmpresa} />
                    <div className='flex gap-2'>
                        <Input name="logo_empresa" label="Logo empresa" type="file" onChange={setLogoEmpresa} />
                        <Input name="logo_representante" label="Logo representante" type="file" onChange={setLogoRepresentante} />
                        <Input name="foto_representante" label="Foto representante" type="file" onChange={setFotoRepresentante} />
                    </div>
                    {
                        error && <ErrorAlert message={error} />
                    }
                </Form>
            </Modal>
            {/* Modal de confirmación para eliminar una empresa*/}
            <ModalConfirmacion
                isOpen={mostrarModalEliminar}
                onClose={limpiarCampos}
                onConfirm={eliminarEmpresa}
                mensaje="¿Estás seguro de que deseas eliminar empresa?"
            >
                {error && <ErrorAlert message={error} />}
            </ModalConfirmacion>


        </div>
    )
}
export default Empresa
